import { ColorName, Icon } from "@zapier/design-system";

type TooltipIconProps = {
  color?: ColorName;
  size?: number;
};

export const TooltipIcon = ({
  color = "neutral800",
  size = 15,
}: TooltipIconProps) => {
  return <Icon color={color} name="alertInfo" size={size} />;
};
